import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { initSentry } from './sentry.js'
import { SentryErrorBoundary } from './ErrorBoundary.jsx'
import FamilyMealApp from './family-meal-pack-app.jsx'

// Initialize Sentry before rendering
initSentry('family-app')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <FamilyMealApp />
    </SentryErrorBoundary>
  </React.StrictMode>,
)
